/* eslint-disable react/no-danger */
import React from 'react';
import main from '../Contents/main.module.css';
import PopupTypesEnum from '../Enums/PopupTypesEnum';
import WarningTypesEnum from '../Enums/WarningTypesEnum';

export default class FigmaPopup extends React.Component {
  static defaultProps = {
    type: PopupTypesEnum.Attention,
    text: 'defaultText',
    textForReason: 'Enter reason for converting',
    okButtonText: '',
    warningType: WarningTypesEnum.WithComment,
    cancelButtonText: 'Cancel',
    okPopupFunction: () => alert('Please, create the okPopupFunction'),
    closePopupFunction: () => alert('Please, create the closePopupFunction'),
    placeholder: 'Enter your reason...',
    iconName: '',
    headerText: '',
    reasonInRequiredInWarningType: false,
    pageCount: 20,
    allCount: 200,
    overButtonText: '',
    showCopyToClipboard: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      okButtonText: this.getOkButtonText(props),
      iconName: this.getIconName(props),
      headerText: this.getHeaderText(props),
      eyebrowText: this.getEyebrowText(props),
      iconToneClassName: this.getIconToneClassName(props),
      reason: '',
      copied: false,
    };
    this.handleTextAreaChange = this.handleTextAreaChange.bind();
    this.keyDownHandler = this.keyDownHandler.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
  }

  copyToClipboard() {
    const text = this.props.text;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).catch(() => {});
    } else {
      // Fallback for non-secure contexts where the async clipboard API is unavailable.
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
    // Briefly swap the icon to a checkmark as feedback.
    this.setState({ copied: true });
    this.copiedResetTimeout = setTimeout(() => this.setState({ copied: false }), 1500);
  }

  keyDownHandler(event) {
    if (event.keyCode === 13) {
      this.props.okPopupFunction();
    }
    if (event.keyCode === 27) {
      this.props.closePopupFunction();
    }
  }

  getIconToneClassName(props) {
    switch (props.type) {
      case PopupTypesEnum.Warning:
      case PopupTypesEnum.Approve:
      case PopupTypesEnum.Attention:
        return 'tone-red';
      case PopupTypesEnum.Success:
        return 'tone-green';
      default:
        return 'tone-navy';
    }
  }

  getEyebrowText(props) {
    switch (props.type) {
      case PopupTypesEnum.Warning:
        return 'WARNING';
      case PopupTypesEnum.Success:
        return 'SUCCESS';
      case PopupTypesEnum.Info:
        return 'INFO';
      default:
        return 'CONFIRM';
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.keyDownHandler, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keyDownHandler, false);
    clearTimeout(this.copiedResetTimeout);
  }

  handleTextAreaChange(e) {
    this.setState({ reason: e.target.value });
  }

  renderFooter() {
    const ok = () => this.props.okPopupFunction();
    const okWithReason = () => this.props.okPopupFunction(this.state.reason);
    const cancel = this.props.closePopupFunction;
    switch (this.props.type) {
      case PopupTypesEnum.Attention:
      case PopupTypesEnum.Approve:
        return (
          <>
            <span className='sp' />
            {this.props.cancelButtonText ? (
              <button
                type='button'
                className='figmabuttondestroy'
                onClick={cancel}
              >
                NO
              </button>
            ) : null}
            <button
              type='button'
              className='figmabutton secondary'
              onClick={ok}
            >
              YES
            </button>
          </>
        );
      case PopupTypesEnum.Success:
        return (
          <>
            <span className='sp' />
            <button
              type='button'
              className='figmabutton secondary'
              onClick={ok}
            >
              OK
            </button>
          </>
        );
      case PopupTypesEnum.Info:
        return (
          <>
            <span className='sp' />
            <button
              type='button'
              className='figmabutton'
              onClick={ok}
            >
              Close
            </button>
          </>
        );
      case PopupTypesEnum.Save:
        return (
          <>
            {this.props.cancelButtonText ? (
              <button
                type='button'
                className='figmabuttondestroy'
                onClick={cancel}
              >
                {this.props.cancelButtonText}
              </button>
            ) : null}
            <span className='sp' />
            <button
              type='button'
              className='figmabutton'
              onClick={ok}
            >
              {this.state.okButtonText}
            </button>
            <button
              type='button'
              className='figmabutton secondary'
              onClick={ok}
            >
              Save & Use
            </button>
          </>
        );
      case PopupTypesEnum.Select:
        return (
          <>
            {this.props.cancelButtonText ? (
              <button
                type='button'
                className='figmabuttondestroy'
                onClick={cancel}
              >
                {this.props.cancelButtonText}
              </button>
            ) : null}
            <span className='sp' />
            <button
              type='button'
              className='figmabutton'
              onClick={ok}
            >
              Page only ({this.props.pageCount})
            </button>
            <button
              type='button'
              className='figmabutton secondary'
              onClick={ok}
            >
              {this.state.okButtonText} ({this.props.allCount})
            </button>
          </>
        );
      case PopupTypesEnum.Warning:
        switch (this.props.warningType) {
          case WarningTypesEnum.WithComment:
            return (
              <>
                {this.props.cancelButtonText ? (
                  <button
                    type='button'
                    className='figmabuttondestroy'
                    onClick={cancel}
                  >
                    {this.props.cancelButtonText}
                  </button>
                ) : null}
                <span className='sp' />
                <button
                  type='button'
                  className='figmabutton secondary'
                  disabled={this.props.reasonInRequiredInWarningType && !this.state.reason}
                  onClick={okWithReason}
                >
                  {this.state.okButtonText}
                </button>
              </>
            );
          case WarningTypesEnum.WithTwoButtons:
            return (
              <>
                <span className='sp' />
                {this.props.cancelButtonText ? (
                  <button
                    type='button'
                    className='figmabuttondestroy'
                    onClick={cancel}
                  >
                    {this.props.cancelButtonText}
                  </button>
                ) : null}
                <button
                  type='button'
                  className='figmabutton secondary'
                  onClick={ok}
                >
                  {this.state.okButtonText}
                </button>
              </>
            );
          case WarningTypesEnum.WithOneButton:
          default:
            return (
              <>
                <span className='sp' />
                <button
                  type='button'
                  className='figmabutton secondary'
                  onClick={ok}
                >
                  Ok
                </button>
              </>
            );
        }
      default:
        return null;
    }
  }

  getHeaderText(props) {
    if (props.headerText) return props.headerText;
    switch (props.type) {
      case PopupTypesEnum.Approve:
      case PopupTypesEnum.Attention:
        return 'Attention';
      case PopupTypesEnum.Success:
        return 'Success!';
      case PopupTypesEnum.Warning:
        return 'Warning!';
      case PopupTypesEnum.Save:
        return 'Save Settings';
      case PopupTypesEnum.Select:
        return 'Select all items';
      case PopupTypesEnum.Info:
        return 'Info';
      default:
        return 'Wrong Type';
    }
  }

  getTitle() {
    // overButtonText is the confirm question only for the two-button confirms.
    // For Warning-with-comment (reason prompt), Save ("Saving as" field label) and
    // Select, overButtonText belongs in the body, so the title stays the type header.
    const usesOverButtonAsTitle =
      this.props.type === PopupTypesEnum.Attention ||
      this.props.type === PopupTypesEnum.Approve ||
      (this.props.type === PopupTypesEnum.Warning && this.props.warningType === WarningTypesEnum.WithTwoButtons);
    if (usesOverButtonAsTitle && this.props.overButtonText) return this.props.overButtonText;
    return this.state.headerText;
  }

  hasHeadMessage() {
    switch (this.props.type) {
      case PopupTypesEnum.Attention:
      case PopupTypesEnum.Approve:
      case PopupTypesEnum.Success:
      case PopupTypesEnum.Warning:
        return true;
      default:
        return false; // Info (boxed in body), Save, Select
    }
  }

  getIconName(props) {
    if (props.iconName) return props.iconName;
    switch (props.type) {
      case PopupTypesEnum.Approve:
      case PopupTypesEnum.Attention:
      case PopupTypesEnum.Warning:
        return 'fa-solid fa-triangle-exclamation';
      case PopupTypesEnum.Success:
        return 'fa-solid fa-circle-check';
      case PopupTypesEnum.Save:
        return 'fa-solid fa-folder-plus';
      case PopupTypesEnum.Info:
      case PopupTypesEnum.Select:
        return 'fa-solid fa-circle-info';
      default:
        return 'fa-solid fa-circle-info';
    }
  }

  getOkButtonText(props) {
    if (props.okButtonText) return props.okButtonText;
    switch (props.type) {
      case PopupTypesEnum.Attention:
        return 'Yes';
      case PopupTypesEnum.Success:
        return 'I understood';
      case PopupTypesEnum.Warning:
        return 'Send';
      case PopupTypesEnum.Save:
        return 'Save';
      case PopupTypesEnum.Select:
        return 'All';
      default:
        return 'Wrong Type';
    }
  }

  renderInfoBox() {
    return (
      <div className={`confirm-info-box${this.props.showCopyToClipboard ? ' has-copy' : ''}`}>
        <p>{this.props.text}</p>
        {this.props.showCopyToClipboard && (
          <i
            className={`fa-solid ${this.state.copied ? 'fa-check is-copied' : 'fa-copy'} confirm-copy`}
            title={this.state.copied ? 'Copied!' : 'Copy to clipboard'}
            onClick={this.copyToClipboard}
          />
        )}
      </div>
    );
  }

  renderBody() {
    switch (this.props.type) {
      case PopupTypesEnum.Info:
        return this.renderInfoBox();
      case PopupTypesEnum.Save:
        return (
          <div className='confirm-field'>
            <label
              htmlFor='figmaPopupSaveName'
              className='ds-label'
            >
              {this.props.overButtonText ? this.props.overButtonText : 'Saving as'}
            </label>
            <input
              type='text'
              id='figmaPopupSaveName'
              className='figmainput'
              placeholder='Type the filter name...'
            />
          </div>
        );
      case PopupTypesEnum.Select:
        return <p className='confirm-select-prompt'>HOW DO YOU WANT TO CONTINUE?</p>;
      case PopupTypesEnum.Warning:
        if (this.props.warningType === WarningTypesEnum.WithComment) {
          return (
            <div className='confirm-field'>
              <label
                htmlFor='figmaPopupReason'
                className='ds-label'
              >
                {this.props.textForReason}
              </label>
              <textarea
                id='figmaPopupReason'
                className='figmatextarea'
                value={this.state.reason}
                placeholder={this.props.placeholder}
                onChange={(e) => this.setState({ reason: e.target.value })}
              />
            </div>
          );
        }
        return null;
      default:
        return null;
    }
  }

  render() {
    const body = this.renderBody();
    return (
      <div className={`${main.confirmationPopup} bravo-ds figma-popup-overlay`}>
        <div
          className='confirm-card popupslide'
          role='dialog'
          aria-modal='true'
        >
          <div className='confirm-banner' />
          <div className='confirm-head'>
            <div className={`confirm-icon ${this.state.iconToneClassName}`}>
              <i className={this.state.iconName} />
            </div>
            <div>
              <div className='eyebrow'>{this.state.eyebrowText}</div>
              <h2>{this.getTitle()}</h2>
              {/* Strings may contain HTML markup from legacy callers; anything else
                  (React elements) must render as children or it stringifies to "[object Object]". */}
              {this.hasHeadMessage() ? (
                typeof this.props.text === 'string' ? (
                  <p dangerouslySetInnerHTML={{ __html: this.props.text }} />
                ) : (
                  <p>{this.props.text}</p>
                )
              ) : null}
            </div>
          </div>
          {body ? <div className='confirm-body'>{body}</div> : null}
          <div className='confirm-foot'>{this.renderFooter()}</div>
        </div>
      </div>
    );
  }
}
